var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-card-wrap"},[_c('div',{staticClass:"blog-cards container"},_vm._l((_vm.blogCardsArray),function(post,index){return _c('BlogCard',{key:index,attrs:{"post":post}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }